// import Blog from "./pages/blog";
import ContactPage from './pages/contact';
import Home from './pages/home';
import About from './pages/about';
import Loans from './pages/loans';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import './styles/App.scss';
import SinglePost from './pages/single-post';
import TermsOfUse from './pages/terms';
import PrivacyPage from './pages/privacy';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import NotFound from './pages/NotFound';
import SupportButton from './componentParts/supportButton';
import MerchantDocumentation from './pages/MerchantDocumentation';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';
import PageFooter from './componentParts/footer';
import TopNav from './componentParts/topNav';
import ChatWidget from './components/ChatWidget';
import React, { useEffect } from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function App() {
  useEffect(() => {
    const handleGlobalScroll = () => {
      const scrollPos = window.scrollY;
      const windowHeight = window.innerHeight;
      const bodyHeight =
        document.body.scrollHeight || document.documentElement.scrollHeight;

      if (scrollPos < 300) {
        document.body.classList.add('at-hero');
      } else {
        document.body.classList.remove('at-hero');
      }

      if (scrollPos + windowHeight > bodyHeight - 400) {
        document.body.classList.add('at-footer');
      } else {
        document.body.classList.remove('at-footer');
      }
    };

    window.addEventListener('scroll', handleGlobalScroll);
    handleGlobalScroll();

    return () => window.removeEventListener('scroll', handleGlobalScroll);
  }, []);

  return (
    <SkeletonTheme baseColor="#f2f4f7" highlightColor="#ffffff">
      <div>
        <CookieBanner />
        <Router>
          <ScrollToTop />
          <TopNav />
          <Switch>
            <Route exact path="/about">
              <About />
            </Route>
            <Route exact path="/blogs">
              <BlogListPage />
            </Route>
            <Route exact path="/contact">
              <ContactPage />
            </Route>
            <Route exact path="/support">
              <Redirect to="/contact" />
            </Route>
            <Route exact path="/terms-of-use">
              <TermsOfUse />
            </Route>
            <Route exact path="/privacy-page">
              <PrivacyPage />
            </Route>
            <Route exact path="/terms">
              <TermsOfUse />
            </Route>
            <Route exact path="/privacy-policy">
              <PrivacyPage />
            </Route>
            <Route path="/blogs/:topicId">
              <SinglePost />
            </Route>
            <Route path="/merchant-documentation" component={MerchantDocumentation} />
            <Route path="/blog/:id">
              <BlogDetailPage />
            </Route>
            <Route exact path="/loans">
              <Loans />
            </Route>
            <Route exact path="/">
              <Home />
            </Route>
            {/* Catch-all route for 404 */}
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
          <PageFooter />
        </Router>
        <SupportButton />
        <ChatWidget />
      </div>
    </SkeletonTheme>
  );
}

export default App;
